import type { SyncTelemetryEvent } from './types';

export interface SyncTelemetrySink {
  record(event: SyncTelemetryEvent): void;
}

class MemorySyncTelemetry implements SyncTelemetrySink {
  private readonly events: SyncTelemetryEvent[] = [];

  record(event: SyncTelemetryEvent): void {
    // Deliberately accepts only the technical schema. Entity payloads, titles,
    // notes, quotes and reviews have no field through which they can leak.
    this.events.push(Object.freeze({ ...event }));
    if (this.events.length > 100) this.events.shift();
  }

  snapshot(): readonly SyncTelemetryEvent[] {
    return [...this.events];
  }
}

export const syncTelemetry = new MemorySyncTelemetry();
